import { jsxs, jsx } from "react/jsx-runtime";
import { MiscPageLayout } from "../MiscPageLayout.js";
import { Message, ButtonGroup, AnchorButton, Button } from "@contember/ui";
import { LogoutLink } from "../LogoutLink.js";
const InvalidIdentityFallback = () => {
  return /* @__PURE__ */ jsxs(MiscPageLayout, { children: [
    /* @__PURE__ */ jsx(Message, { intent: "danger", size: "large", flow: "generousBlock", children: "Failed to fetch an identity" }),
    /* @__PURE__ */ jsxs(ButtonGroup, { orientation: "vertical", children: [
      /* @__PURE__ */ jsx(AnchorButton, { href: window.location.href, children: "Reload" }),
      /* @__PURE__ */ jsx(LogoutLink, { Component: Button, children: "Login again" })
    ] })
  ] });
};
export {
  InvalidIdentityFallback
};
//# sourceMappingURL=InvalidIdentityFallback.js.map
